import { Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { isEmpty } from "lodash";
import {
  IDeliveryOrderDetail,
  IPaginateApiResponse,
  IPrepareDetail,
} from "model";
import moment from "moment";
import { useEffect, useState } from "react";
import { PrepareActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import i18n, { _t, translations, I18nTranslator } from "utils/i18n";

interface IProductListProps {
  deliveryOrderHeaderId: string;
}
const ProductList = (props: IProductListProps) => {
  const { deliveryOrderHeaderId } = props;
  const dispatch = useAppDispatch();
  const data = useAppSelector(
    (state) => state.PrepareReducer.prepareDetail.data
  ) as IPaginateApiResponse<IPrepareDetail[]>;
  const action = useAppSelector(
    (state) => state.PrepareReducer.prepareDetail.action
  );

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    _getAllProducts();
  }, [searchText]);

  const _getAllProducts = (pageNumber = 1) => {
    dispatch(
      PrepareActions.getPrepareDocumentDetail.request({
        pageNumber: pageNumber,
        pageSize: 100,
        deliveryTicketHeaderId: deliveryOrderHeaderId,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.receive.productName),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "batchCode",
      headerName: I18nTranslator(translations.receive.batchCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.receive.quantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "packQuantity",
      headerName: I18nTranslator(translations.receive.cartonS),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "packType",
      headerName: I18nTranslator(translations.receive.cartonType),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "packSize",
      headerName: I18nTranslator(translations.receive.cartonSpecification),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "packWeight",
      headerName: I18nTranslator(translations.receive.cartonWeight),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "productQuantity",
      headerName: I18nTranslator(translations.receive.oddQuantity),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "productCase",
      headerName: I18nTranslator(translations.receive.oddCartonS),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "productUnit",
      headerName: I18nTranslator(translations.receive.uom),
      size: 100,
      align: "center",
    }),
    TableHelper.createCell({
      field: "productWeight",
      headerName: I18nTranslator(translations.receive.oddCartonWeight),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "userPrepare",
      headerName: I18nTranslator(translations.receive.preparedBy),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "userVerify",
      headerName: I18nTranslator(translations.receive.checkedBy),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "palletCode",
      headerName: I18nTranslator(translations.receive.pallet),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "deliveredQty",
      headerName: I18nTranslator(translations.receive.deliveredQuantity),
      size: "small",
      align: "right",
    }),
  ];

  return (
    <AppTable
      loading={action.includes(
        PrepareActions.getPrepareDocumentDetail.requestName
      )}
      data={data}
      columns={COLUMNS}
      onSearch={setSearchText}
      onChangePage={_getAllProducts}
      hideHeader
      hideSearch
      removeActionColumn
      defaultHeaderTable={300}
    />
  );
};

export default ProductList;
